import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import CustomizedTables from '../../common/Table';
import { deleteProperties, listProperties } from './Properties.service';
import { useCountryParam, buildUrlWithCountry } from '../../common/util/useCountryParam';
import PropertiesIndia from './PropertiesIndia';

const PropertiesList: React.FC = () => {
    const country = useCountryParam();
    
    // If country is India, show the India-specific properties component
    if (country === 'india') {
        return <PropertiesIndia />;
    }
    
    // For other countries (UK, etc.), show the original properties list
    const columns: any[] = [
        // { key: "id", label: "ID", minWidth: 90 },
        { key: "name", label: "Name", minWidth: 150 },
        { key: "rentOrPrice", label: "Price", minWidth: 130 },
        { key: "bathroom", label: "Bathroom", minWidth: 150 },
        { key: "location", label: "Location", minWidth: 150 },
        { key: "bedrooms", label: "bedrooms", minWidth: 100 },
        { key: "images", label: "Images", minWidth: 170 },
        { key: "status", label: "Status", minWidth: 200 },
        { key: "propertyStatus", label: "Property Status", minWidth: 200 },
        { key: "type", label: "Property Type", minWidth: 200 },
    ];
    
    return (
        <Box sx={{ paddingY: 6, width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Properties List ({country.toUpperCase()})</h2>

                <Button variant="contained" color="primary" size='small' sx={{
                    backgroundColor: "#10374A", // Custom background color
                    color: "#FFFFFF",           // Custom text color
                    "&:hover": {
                        backgroundColor: "#08293D", // Custom hover color
                    }, height: '40px'
                }} component={Link} to={buildUrlWithCountry('/addProperty', country)}>
                    Add New Property
                </Button>
            </Box>
            <CustomizedTables
                columns={columns}
                listService={listProperties}
                deleteService={deleteProperties}
                editLink={'/editProperty'}
            />
        </Box>
    );
};

export default PropertiesList;
